import unescape from 'unescape';

window.Shopify = window.Shopify || {};
window.Shopify.currency = window.Shopify.currency || {};

const defaultMoneyFormat = '£{{amount}}';
const moneyFormat = window.Shopify.money_format || defaultMoneyFormat;
const currencyInfo = {
    code: window.Shopify.currency.code || 'GBP',
    rate: window.Shopify.currency.rate || 1.0,
    moneyFormat: unescape(moneyFormat, 'all'),
};


class Money {

    static moneyFormatter(format) {
        return (cents) => this.moneyFormat(cents, format)
    }

    static stripTags(str) {
        const tmp = document.createElement('div');
        tmp.innerHTML = str;
        return tmp.textContent || tmp.innerText;
    }

    static convertMoney(baseCents) {
        return Math.round(Math.ceil(baseCents * currencyInfo.rate / 100) * 100);
    }

    static moneyFormat(cents, format, convert = true) {
        var value = '',
            placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = (format || currencyInfo.moneyFormat);

        if (typeof cents == 'string') {
            cents = cents.replace('.','');
        }

        if (cents === null || typeof cents === 'undefined') {
            return currencyInfo.moneyFormat.replace('{{amount}}', ' --');
        }

        if (convert) {
            cents = this.convertMoney(cents);
        }

        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal   = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number/100.0).toFixed(precision);

            var parts   = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents   = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }

        switch(formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    }
}

export default Money.moneyFormatter();
